module.exports = __webpack_public_path__ + "static/img/help.6fce1335.png";